import React, { useState } from 'react';
import { Container } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../../shared/providers';
import { ModeSelector } from './components/ModeSelector/ModeSelector';
import { GuidedChallengeCreation } from './components/GuidedChallengeCreation/GuidedChallengeCreation';
import { FreeChallengeCreation } from './components/FreeChallengeCreation/FreeChallengeCreation';

import { CreationMode } from './NgzChallengeCreate.settings';

const NgzChallengeCreate = () => {
  const [creationMode, setCreationMode] = useState<CreationMode | null>(null);

  const renderContent = () => {
    switch (creationMode) {
      case 'GUIDED':
        return <GuidedChallengeCreation />;
      case 'FREEFORM':
        return <FreeChallengeCreation />;
      default:
        return <ModeSelector onNext={setCreationMode} />;
    }
  };

  return <Container>{renderContent()}</Container>;
};

angularizeWithProviders(NgzChallengeCreate, 'ngzChallengeCreate', {});
